export default __webpack_public_path__ + "static/media/searchIcon.9e74090f.svg";